import React from "react";
import { Handle } from 'react-flow-renderer';
import { handlesColors } from "./";

export const HandleOutputRed =  ({isConnectable = true, onConnect, top = "unset", bottom = "0px", height = "50%", borderRadius = "0px 0px 5px 0px"})  => {
  return (
    <Handle
    type="source"
    position="right"
    id="R"
    style={{  backgroundColor: handlesColors.R, transform: "translateY(0%)", bottom, top, borderRadius, height, border: "0px solid white", width: "10px", right: "-10px"  }}
    isConnectable={isConnectable}
    onConnect={onConnect}
  ></Handle>
  );
}
